module.exports = __webpack_public_path__ + "img/hoslogo13.f5a34152.png";